import { useEffect, useState } from "react";

export type StaggeredRevealPhase = "hidden" | "revealing" | "complete";

export const useStaggeredSecondaryReveal = (
    totalItems: number,
    phase: StaggeredRevealPhase,
    intervalMs: number,
): number => {
    const [revealedCount, setRevealedCount] = useState(() =>
        phase === "complete" ? totalItems : 0,
    );

    useEffect(() => {
        if (phase === "hidden") {
            setRevealedCount(0);
            return;
        }

        if (phase === "complete" || totalItems === 0) {
            setRevealedCount(totalItems);
            return;
        }

        setRevealedCount(0);
        let current = 0;
        const intervalId = window.setInterval(() => {
            current = Math.min(totalItems, current + 1);
            setRevealedCount(current);
            if (current >= totalItems) {
                window.clearInterval(intervalId);
            }
        }, intervalMs);

        return () => {
            window.clearInterval(intervalId);
        };
    }, [phase, totalItems, intervalMs]);

    return revealedCount;
};
